// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import PanToolIcon from "@mui/icons-material/PanTool";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {changeWorkIssuance} from "../../workIssuanceSlice";

// main function
export default function IssuedOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const performIssued = () => {
        // dispatchData(changeOwed({issuedState: true, owedNewStatus: 'Issued'}));
        dispatchData(changeWorkIssuance({newStatus:  '3242', updateCdpStatus: true}));
        onMenuClose();
    };

    return (

        <Box>
            {(
                    // (rowCdpStatus === "2351" ||  rowCdpStatus === "3410")
                    (rowCdpStatus === "2351" )
                ) &&
                <MenuItem onClick={performIssued}>
                    <ListItemIcon>
                        <MailOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Issue</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
